import pym from "pym.js";
import { useCallback, useEffect, useState } from "react";

declare global {
  interface Window {
    pymChild?: pym.Child;
  }
}

export function getPymChild(): pym.Child {
  window.pymChild ??= new pym.Child();
  return window.pymChild;
}

export const usePymJs = (enabled = true) => {
  const [element, setElement] = useState<HTMLDivElement>();
  const captureElement = useCallback((dom: HTMLDivElement | null) => {
    if (!dom) return;
    setElement(dom);
  }, []);

  useEffect(() => {
    if (!enabled || element === undefined) return;

    const handler = () => {
      getPymChild().sendHeight();
    };

    const mutationObserver = new MutationObserver(handler);
    mutationObserver.observe(element, { childList: true, subtree: true });

    const resizeObserver = new ResizeObserver(handler);
    resizeObserver.observe(element);

    getPymChild().onMessage("pym:request-height", handler);

    return () => {
      mutationObserver.disconnect();
      resizeObserver.disconnect();
    };
  }, [element, enabled]);

  return {
    captureElement,
  };
};
